import React, {useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { TableCell, Button, TableRow, Checkbox, Modal, Tab } from '@material-ui/core';
import { Link, Announcement} from '@material-ui/icons';
import PaxInfoSecondary from './PaxInfoSecondary';
import { IconButton } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import _ from 'lodash'
import { FormattedSSRs } from '../../util/formatSSRs';
import { handleCheckInChange } from '../../util/checkInChange';
import NewTextModal from '../../modals/NewText';
import RemarksModal from '../../modals/Remarks';
import { markTextsAsOld, fetchNewTexts, resetRemarks } from '../../../../store/dcs'
import { matchTextsToPax } from '../../util/matchSmsToPax'
import { FaGoogle } from "react-icons/fa";
import checkPermissions from "../../../../utils/checkPermissions";

export const PaxInfoMainDisplay = (props) => {
  const dispatch = useDispatch()
  const {classes, pax, modalClasses} = props;
  const airline = useSelector(state => state.entities.dcs.airline)
  const [ETStatus, setETStatus] = useState(pax.ETStatus)
  const [openAccordion, setOpenAccordion] = React.useState(false);
  const [openRemarks, setOpenRemarks] = useState(false);
  const [openNewText, setOpenNewText] = useState(false);
  const userType = useSelector(state => state.entities.auth.userType)

  let {newTexts} = props;
  newTexts = newTexts.filter((item) => item.rloc);

  let modalTexts = matchTextsToPax(newTexts, pax);
  
  const ids = modalTexts.map((text) => text.id);

  const handleOpenNewText = () => {
    setOpenNewText(true);
    dispatch(markTextsAsOld(ids))
  };
  const handleCloseNewText = () => {
    dispatch(fetchNewTexts());
    setOpenNewText(false);
  };

  const handleCloseRemarks = () => {
    dispatch(resetRemarks());
    setOpenRemarks(false);
  };

  const handleOpenRemarks = () => {
    setOpenRemarks(true);
  };

  return (
    <React.Fragment>
      <TableRow key={pax.TicketNumber}>
        <TableCell className={classes.tableCellLessPad} align="center" sx={{
          '& .MuiTableCell-root':{
            padding: '2px'
          }
        }}>
        <div>
          <Button variant="contained" size="small" onClick={handleOpenRemarks} disabled={!checkPermissions(userType, airline, 'viewComment')}>
            {pax.FirstName} {pax.LastName} {pax.Kal === "1" ? <Link/> : pax.GDS === "1"? <FaGoogle/> : ``}
          </Button>
          <Modal 
            open={openRemarks} 
            onClose={handleCloseRemarks} 
            aria-labelledby="simple-modal-title" 
            aria-describedby="simple-modal-description"
          >
            <RemarksModal pax={pax} closeModal={handleCloseRemarks} modalClasses={modalClasses} />
          </Modal>
        </div>
        </TableCell>
        <TableCell className={classes.tableCellLessPad} align="center">{pax.PNRRefNo}</TableCell>
        <TableCell className={classes.tableCellLessPad} style={{fontSize: 'large'}} align="center">
          <FormattedSSRs pax={pax} isMobile={true} />
        </TableCell>
        {/* NOTE // mui tables automatically add padding-right of 16px to the last child, so I overwrote that here in the style prop */}
        <TableCell className={classes.tableCellLessPad}  style={{paddingRight: '3px'}} align="center">
          {/* <Checkbox checked={ETStatus === "C"} onChange={() => {handleCheckInChange(pax, dispatch, ETStatus, setETStatus)}} disabled={ETStatus === "F" || !checkPermissions(userType, airline, 'checkIn')} /> */}
          <Checkbox checked={ETStatus === "C" || ETStatus === "F"} onChange={() => {handleCheckInChange(pax, dispatch, ETStatus)}} disabled={ETStatus === "F"} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpenAccordion(!openAccordion)}>
            {openAccordion ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {
          !!modalTexts?.length && checkPermissions(userType, 'textPax') ? 
          <TableCell>
            <Announcement style={{color: 'red'}} onClick={handleOpenNewText} /> 
            <Modal
              open={openNewText} 
              onClose={handleCloseNewText} 
              aria-labelledby="simple-modal-title" 
              aria-describedby="simple-modal-description"
            >
              <NewTextModal texts={modalTexts} modalClasses={modalClasses} />
            </Modal>
          </TableCell>
          : <TableCell></TableCell>
        }
      </TableRow>
      <PaxInfoSecondary openAccordion={openAccordion} pax={pax} modalClasses={modalClasses} />
    </React.Fragment>
  )
};